import { render, staticRenderFns } from "./DebtInstallmentWarrantyTable.vue?vue&type=template&id=3b4d851d&scoped=true"
import script from "./DebtInstallmentWarrantyTable.vue?vue&type=script&lang=js"
export * from "./DebtInstallmentWarrantyTable.vue?vue&type=script&lang=js"
import style0 from "./DebtInstallmentWarrantyTable.vue?vue&type=style&index=0&id=3b4d851d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4d851d",
  null
  
)

export default component.exports